export type TranslatorFunction = (input: string, args: { [key: string]: string | number | undefined }) => string

// Namespaces
export const COMMON = 'common'
export const PERMITS_STATISTICS = 'permitsStatistics'
export const RIGHTS_STATISTICS = 'rightsStatistics'
